import { Link, useLocation } from 'react-router-dom'
import { SECTION_PATH_BY_LABEL, type SectionLabel } from './sections'
import { AMBITI_STATS, type AmbitoId } from '../data/ambitiStats'
import { useAmbitoSelection } from './AmbitoSelectionContext'

export type SezioneCard = SectionLabel

export default function SectionBadge({ sezione }: { sezione: SezioneCard }) {
  const location = useLocation()
  const selectedAmbitoFromContext = useAmbitoSelection()

  const storedAmbitoId = typeof window !== 'undefined'
    ? (window.localStorage.getItem('mb_selected_ambito') as AmbitoId | null)
    : null

  const ambitoFromPdzRoute = (() => {
    const match = location.pathname.match(/^\/pianodizona\/([^/]+)\//i)
    if (!match?.[1]) return null
    const routeKey = match[1].toLowerCase()
    const ambito = AMBITI_STATS.find(a => a.nome.toLowerCase() === routeKey)
    return ambito?.id ?? null
  })()

  const resolvedAmbitoId = ambitoFromPdzRoute
    ?? (selectedAmbitoFromContext !== undefined ? selectedAmbitoFromContext : storedAmbitoId)
  const ambitoName = resolvedAmbitoId ? AMBITI_STATS.find(a => a.id === resolvedAmbitoId)?.nome : null
  const rightLabel = ambitoName ? `Ambito di ${ambitoName}` : 'Provincia MB'

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        marginBottom: 8,
      }}
    >
      <Link
        to={SECTION_PATH_BY_LABEL[sezione]}
        style={{
          fontSize: 10,
          fontWeight: 700,
          color: 'var(--text-3)',
          letterSpacing: '0.02em',
          textDecoration: 'none',
          display: 'inline-block',
        }}
      >
        {sezione}
      </Link>
      <span
        style={{
          fontSize: 10,
          fontWeight: 600,
          color: 'var(--text-3)',
          letterSpacing: '0.02em',
          whiteSpace: 'nowrap',
          textAlign: 'right',
        }}
      >
        {rightLabel}
      </span>
    </div>
  )
}
